import React from 'react'
// import { Spinner } from "@blueprintjs/core";
import moment from 'moment';
import { Translate } from 'react-redux-i18n';
import Image from '../Image';
import ReduxLinkDecorator from '../../containers/ReduxLinkDecorator';

const UserBookingHistory = ({ user, user_bookings, bookings }) => {
    let days_booked = 0;
    if (user_bookings) {
        user_bookings.forEach(booking => {
            const start = moment(booking.start_time);
            const end = moment(booking.end_time);
            days_booked += end.diff(start, 'days');
        })
    }
    // let total_booked_days = 0;
    // if(bookings){        
    //     bookings.forEach(booking=>{         
    //         const start = moment(booking.start_time);
    //         const end = moment(booking.end_time);
    //         total_booked_days += end.diff(start, 'days');        
    //     })         
    // }

    // const user_percent = days_booked/total_booked_days;
    return (
        <div className="user-item">
            <ReduxLinkDecorator goTo={`public-profile/${user.guid}`}>
                <div className="image user-avatar size-56">
                    <Image src={user.image_url} alt={user.f_name} />
                </div>
                <div className="meta">
                    <div className="context">
                        <p>
                            {days_booked}
                            <Translate value="booking.days_booked" />
                        </p>
                    </div>
                    <div className="name">{user.f_name} {user.l_name}</div>
                </div>
            </ReduxLinkDecorator>
            {/* <div className="user-actions">
                <div className="progress-container">
                    <Spinner intent="primary" size="56" value={user_percent?user_percent:0} />
                    <div className="progress-percent">{((user_percent?user_percent:0)*100).toFixed(0)}%</div>
                </div>
            </div> */}
        </div>
    )
}

export default UserBookingHistory;